import { useMemo } from 'react';
import { Box }               from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid/models/gridRows';

import { useUsers }           from '@shared/hooks/useUsers';
import { PhoenixGrid }        from '@shared/components/grid/PhoenixGrid';
import { mapGridIndexes }     from '@shared/commonFunctions';
import { SelectAutocomplete } from '@shared/inputs/SelectAutocomplete';
import { GroupUser, IRoleUser } from '@shared/interfaces';
import { SectionLabel, excludedRowClassName, TableHeader } from '@styles/Admin-tools/Roles/RoleModalStyles';

import { useTable } from '@shared/hooks/useTable';
import { roleUsersColumns } from '..';

interface IAddUsersIndividuallyProps {
  title: string;
  data: IRoleUser[];
  onDeleteUser(userId: string): void;
  onSelectUser(option: GroupUser): void;
}

export const UsersManipulator = ({ title, data, onDeleteUser, onSelectUser }: IAddUsersIndividuallyProps) => {
  const { sortModel, setSortModel } = useTable({ sortModel: [{ field: 'userName', sort: 'asc' }] });

  const { users } = useUsers();

  const userSelectOptions = useMemo(() => users?.groupUsers?.map((user) => ({
    value: { ...user, value: user.userId },
    label: user.userName,
  })) || [], [users]);

  const includedUsersGridActions = {
    onDelete: (row: GridValidRowModel) => onDeleteUser(row.userId),
  };

  return (
    <Box sx={{ height: '100%' }}>
      <TableHeader>
        <SectionLabel mb="0">{title}</SectionLabel>
        <SelectAutocomplete
          value=""
          placeholder='Select Users'
          options={userSelectOptions}
          onChange={(user: GroupUser) => onSelectUser(user)}
        />
      </TableHeader>

      <PhoenixGrid
        canNotCopy
        canNotEdit
        withoutConfirmation
        disableSelectionOnClick
        name="User"
        height="265px"
        pageSize={25}
        columns={[roleUsersColumns[0]]}
        rows={mapGridIndexes(data)}
        actions={includedUsersGridActions}
        getRowClassName={excludedRowClassName}
        sortModel={sortModel}
        onSortModelChange={setSortModel}
      />
    </Box>
  );
};
